import script from "./SessionWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionWarning.vue?vue&type=script&setup=true&lang=js"

import "./SessionWarning.vue?vue&type=style&index=0&id=4243dbf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4243dbf8"]])

export default __exports__